<template>
  <VDialog v-model="isShowModal" max-width="500">
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-information-outline" class="mr-2" />
        Confirmation
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleClose()" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VCardText>
          <div class="d-flex flex-column align-center justify-center">
            <VIcon icon="mdi-information" color="warning" size="64" class="my-2" />
            <p class="text-center">Are you sure you want to delete this document? This action cannot be undone.</p>
          </div>
          <VRow class="mt-4">
            <VCol cols="12" class="pt-2">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="red" block flat @click="handleDelete()">
                Delete
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleClose()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>
<script>
import { mapActions } from 'vuex';
// Service
import documentsService from '@/services/documents-service/documents.service';
// Text
import { successDeleteDocumentText, errorDeleteDocumentText } from '@/text/snackbarsText';
export default {
  emits: ['update:modelValue', 'success'],
  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },
  props: {
    modelValue: Boolean,
    documentId: String
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleDelete() {
      this.isLoading = true;
      try {
        await documentsService.deleteDocument({ documentId: this.documentId });
        this.showSnackbar({ text: successDeleteDocumentText, color: 'green' });
        this.handleSuccess(this.documentId);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: errorDeleteDocumentText, color: 'red' });
      } finally {
        this.isLoading = false;
      }
    },
    handleSuccess(documentId) {
      this.$emit('update:modelValue', false);
      this.$emit('success', documentId);
    },
    handleClose() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>
